<template>
  <div id="app">
    <!-- 头部 -->
    <AppHeader />

    <!-- Banner轮播 -->
    <div class="banner" :style="{ backgroundImage: 'url(' + banners[currentBanner] + ')' }" @click="goBannerLink()">
    </div>

    <!-- 数据统计 -->
    <section class="stats-section">
      <div class="container">
        <div style="text-align:center; margin-bottom: 30px;">
          <div style="color: #e5e5e5; font-size: 36px;">WHO ARE WE</div>
          <div style="color: #353535; font-size: 36px; font-weight: bold;">我们的优势</div>
        </div>
        <div class="stats-grid">
          <div v-for="stat in stats" :key="stat.label">
            <div class="stats-number">{{ stat.number }}</div>
            <div class="stats-label" style="font-weight: bold;">{{ stat.label }}</div>
            <div class="stats-desc">{{ stat.desc }}</div>
          </div>
        </div>
      </div>
    </section>

    <!-- 我们的服务 -->
    <section class="section bbg">
      <div class="section-label" style="color: rgb(102, 102, 102);">OUR SERVICES</div>
      <div class="section-title" style="color: #ffffff;">我们的服务</div>
      <div class="container"
        style="background-color: #ffffff; box-shadow: 5px 10px 20px 1px rgba(0,0,0,0.1) ;padding: 30px 30px 0px 30px;">


        <div class="service-block">
          <div class="service-image">
            <img src="//1.s140i.faiscm.com/2/AIwBCAAQAhgAIJn17NUFKNvO7dIGMIAPOPcJ!500x500.jpg" alt="企业优势">
          </div>
          <div>
            <div class="service-title">企业优势 <span class="service-title-en">Enterprise Advantage</span></div>
            <div class="service-text">{{ enterpriseAdvantage }}</div>
          </div>
        </div>

        <div class="service-block" style="padding-bottom: 30px;">
          <div>
            <div class="service-title">服务优势 <span class="service-title-en">Service Advantage</span></div>
            <div class="service-text">{{ serviceAdvantage }}</div>
          </div>
          <div class="service-image">
            <img src="//1.s140i.faiscm.com/2/AIwBCAAQAhgAILqXm9oFKK38wIIGMIAPOIAK!500x500.jpg" alt="服务优势">
          </div>
        </div>
      </div>
    </section>

    <!-- 产品系列 -->
    <section class="section" style="background: #fafafa;">
      <div class="container">
        <div class="section-label">OUR CASES</div>
        <div class="section-title">产品系列</div>
      </div>

      <div class="products-wrapper">
        <div class="scroll-arrow scroll-arrow-left" @click="scrollProducts(-1)">‹</div>

        <div class="products-slider" ref="productsSlider">
          <div class="product-card" v-for="product in products" :key="product.name" @click="goProduct(product)">
            <img :src="product.image" :alt="product.name">
            <div class="product-info">
              <div class="product-name">{{ product.name }}</div>
              <div class="product-desc">{{ product.desc }}</div>
            </div>
          </div>
        </div>

        <div class="scroll-arrow scroll-arrow-right" @click="scrollProducts(1)">›</div>
      </div>
    </section>

    <!-- 定制服务 -->
    <section class="custom-section">
      <div class="container">
        <div style="text-align:center; margin-bottom: 0;">
          <div class="section-label">Custom Services</div>
          <div class="section-title" style="margin-bottom:0;">定制服务</div>
        </div>
      </div>

      <div class="custom-wrapper">
        <div class="custom-bg-img">
          <img :src="customMainImage" alt="定制服务">
        </div>

        <div class="custom-content">
          <div class="custom-title">专属方案定制，一站式服务</div>
          <div class="custom-text">
            依托多元定制能力，可根据客户个性化需求，量身打造专属节日礼包、定制卡册与专题页面设计；同时支持特色活动策划，定制专属打卡小程序，全方位贴合品牌场景与活动需求，一站式满足礼品定制、视觉设计、线上互动工具开发等多元化服务，打造差异化专属体验。
          </div>
          <ul class="custom-list">
            <li>专属物料定制｜礼包卡册量身打造，专题页面定制设计</li>
            <li>创意活动策划｜定制打卡小程序，赋能多元营销场景</li>
            <li>全维度定制服务，物料+页面+线上工具一体化打造</li>
          </ul>
        </div>

        <div class="marquee-overlay">
          <div class="marquee-track">
            <div class="marquee-card" v-for="(img, idx) in marqueeImages" :key="idx" @click="openLightbox(img)">
              <img :src="img" alt="">
            </div>
            <div class="marquee-card" v-for="(img, idx) in marqueeImages" :key="'clone-' + idx"
              @click="openLightbox(img)">
              <img :src="img" alt="">
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 图片预览弹窗 -->
    <div class="lightbox" v-if="lightboxVisible" @click="closeLightbox">
      <span class="lightbox-close">&times;</span>
      <img :src="lightboxImage" class="lightbox-content" @click.stop>
    </div>
    <!-- 底部 -->
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/head.vue'
import AppFooter from '@/components/foot.vue'

export default {
  name: 'Home',
  components: {
    AppHeader,
    AppFooter
  },
  data() {
    return {// ... 其他数据
      lightboxVisible: false,
      lightboxImage: '',
      currentBanner: 0,
      banners: [
        require('../src/assets/bb2.png'),
        require('../src/assets/bb1.jpg'),
        require('../src/assets/bb3.jpg'),
        require('../src/assets/bb2.jpg'),
        require('../src/assets/bb5.png'),

      ],
      stats: [
        { number: '600+', label: '城市', desc: '经营分布城市' },
        { number: '40W+', label: '产品', desc: '优质产品' },
        { number: '1500+', label: '经验', desc: '超过1500家客户服务经验' }
      ],
      enterpriseAdvantage: '我们以品质福利供应（超级商城、文化 / 生日福利等）、定制化咨询与多模态兑换、灵活定制方案（党群 / 员工关怀 / 节日礼品等）及数字运营为支撑，依托技术中台与物流网络，实现高效管理与配送；同时为企业赋能合规福利方案、助力文化建设，为员工提供优质选择、满足个性需求，让福利更实用、更贴心。',
      serviceAdvantage: '我们拥有专业化服务体系：依托集采优势提供价格优惠，支持独享定制方案，提供高效售后与多元增值服务；同时承诺价优（差价双倍补）、正品（假一赔三）、全年在线服务及合约保障，为您的福利采购保驾护航。',
      products: [
        { name: '工会消费券', desc: '基层工会可结合实际在现行规定基础上，每年发放一次工会消费券...', image: require('../src/assets/c7.png'), path: '/coupon' },
        { name: '悦动态', desc: '智慧企业运动健康管理系统，用互联网+AI运动+游戏化的运营...', image: require('../src/assets/c5.png'), path: '/contact' },
        { name: '生日卡券', desc: '甄选知名烘焙品牌，覆盖生日、节庆、日常等多元场景，多种规...', image: require('../src/assets/c3.png'), path: '/service' },
        { name: '电影演出', desc: '联动主流影院、各大演出场馆，覆盖热门院线电影、话剧歌剧...', image: require('../src/assets/c4.png'), path: '/cases' },
        { name: '福利优选', desc: '商城商品随心选，福利优选更贴心甄选商城优质好物，打造专属...', image: require('../src/assets/c1.png'), path: '/' },
        { name: '年节礼包', desc: '商城商品随心选，福利优选更贴心甄选商城优质好物，打造专属...', image: require('../src/assets/c2.png'), path: '/news' },
      ],
      customMainImage: '//34188381.s21i.faiusr.com/4/ABUIABAEGAAgtdWmzwYooOnr1AMwuAg4oAs!600x600.png',
      marqueeImages: [
        require('../src/assets/a1.png'),
        require('../src/assets/a2.png'),
        require('../src/assets/a3.png'),
        require('../src/assets/a4.png'),
        require('../src/assets/a5.png')
      ]
    }
  },
  methods: {
    goBannerLink() {
      const links = [
        '/pruduct1',  // 第1张banner跳转
        '/pruduct2',  // 第2张banner跳转
        '/pruduct3',  // 第3张banner跳转
        '/pruduct4',  // 第4张banner跳转
        '/pruduct5',  // 第5张banner跳转
      ]
      console.log(links[this.currentBanner])
      if (links[this.currentBanner] === '/pruduct1') { }
      if (links[this.currentBanner] === '/pruduct2') {
        // this.$router.push('/news')
        const routedata3 = this.$router.resolve('/news');
        window.open(routedata3.href, '_blank')
      }
      if (links[this.currentBanner] === '/pruduct3') {

        // this.$router.push('/service')

        const routedata2 = this.$router.resolve('/service');
        window.open(routedata2.href, '_blank')

      }
      if (links[this.currentBanner] === '/pruduct4') {
        // this.$router.push('/cases')
        const routedata1 = this.$router.resolve('/cases');
        window.open(routedata1.href, '_blank')
      }
      if (links[this.currentBanner] === '/pruduct5') {
        // this.$router.push('/contact')
        const routedata = this.$router.resolve('/contact');
        window.open(routedata.href, '_blank')

      }
      // this.$router.push(links[this.currentBanner])
    },
    autoScroll() {
      this.scrollProducts(1)
    },

    openLightbox(imageSrc) {
      this.lightboxImage = imageSrc
      this.lightboxVisible = true
      // 防止背景滚动
      document.body.style.overflow = 'hidden'
    },
    closeLightbox() {
      this.lightboxVisible = false
      this.lightboxImage = ''
      // 恢复背景滚动
      document.body.style.overflow = ''
    },
    goProduct(product) {
      const routedata = this.$router.resolve(product.path);
      window.open(routedata.href, '_blank')
    },
    // scrollProducts(direction) {
    //   const slider = this.$refs.productsSlider
    //   const scrollAmount = 297
    //   slider.scrollBy({
    //     left: direction * scrollAmount,
    //     behavior: 'smooth'
    //   })
    // }
    scrollProducts(direction) {
      const slider = this.$refs.productsSlider
      const scrollAmount = 297

      // 向右滚动：如果已经滚到最右边，就回到最左边
      if (direction === 1) {
        if (slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 10) {
          slider.scrollTo({ left: 0, behavior: 'smooth' })
          return
        }
      }

      // 向左滚动：如果已经滚到最左边，就去到最右边
      if (direction === -1) {
        if (slider.scrollLeft <= 10) {
          slider.scrollTo({ left: slider.scrollWidth, behavior: 'smooth' })
          return
        }
      }

      slider.scrollBy({
        left: direction * scrollAmount,
        behavior: 'smooth'
      })
    }
  },
  mounted() {
    // 原来就有的banner定时器
    setInterval(() => {
      this.currentBanner = (this.currentBanner + 1) % this.banners.length
    }, 4000)

    // 新增：产品系列每2秒自动滚动
    this.productTimer = setInterval(() => {
      this.autoScroll()
    }, 3000)
  },// 新增：组件销毁前清除定时器

  // 新增：组件销毁前清除定时器
  beforeDestroy() {
    if (this.productTimer) {
      clearInterval(this.productTimer)
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Microsoft YaHei', 'PingFang SC', sans-serif;
  color: #353535;
  line-height: 1.6;
}

.section.bbg {
  background: url(../src/assets/bbg.png) no-repeat;
  width: 100%;
  background-size: contain;
  min-height: 300px;
}

.section {
  padding: 80px 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-label {
  text-align: center;
  color: #e5e5e5;
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 10px;
}

.section-title {
  text-align: center;
  color: #353535;
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 50px;
}

.banner {
  height: 800px;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  transition: background-image 1s;
}

.stats-section {
  background: #fff;
  padding: 60px 0;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  text-align: center;
}

.stats-number {
  font-size: 60px;
  color: #d81b43;
  font-weight: bold;
}

.stats-label {
  font-size: 22px;
  color: #4c4c4c;
  margin: 10px 0;
}

.stats-desc {
  font-size: 14px;
  color: #b2b2b2;
}

.service-block {
  text-align: left;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
  margin-bottom: 80px;
}

.service-image img {
  width: 100%;
  height: auto;
  border-radius: 8px;
}

.service-title {
  font-size: 26px;
  font-weight: bold;
  color: #353535;
  margin-bottom: 20px;
}

.service-title-en {
  color: #e5e5e5;
  margin-left: 10px;
}

.service-text {
  font-size: 16px;
  line-height: 30px;
  color: #6d6d6d;
}

.products-wrapper {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.products-slider {
  display: flex;
  gap: 20px;
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-width: none;
  padding: 10px 0 20px;
  -ms-overflow-style: none;
  /* background-color: #888; */
}

.products-slider::-webkit-scrollbar {
  display: none;
}

.product-card {
  width: calc((100% - 60px) / 4);
  flex-shrink: 0;
  scroll-snap-align: start;
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s, box-shadow 0.3s;
  cursor: pointer;
}

.product-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.product-card img {
  width: 100%;
  height: 470px;
  object-fit: cover;
  display: block;
}

.product-info {
  padding: 20px;
  text-align: left;
}

.product-name {
  font-size: 18px;
  font-weight: bold;
  color: #353535;
  margin-bottom: 8px;
}

.product-desc {
  font-size: 14px;
  color: #888;
  line-height: 1.6;
  color: #6d6d6d;
}

.scroll-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid #ddd;
  border-radius: 50%;
  cursor: pointer;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #666;
  transition: all 0.3s;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.scroll-arrow:hover {
  background: #c40000;
  color: #fff;
  border-color: #c40000;
}

.scroll-arrow-left {
  left: 0;
}

.scroll-arrow-right {
  right: 0;
}

.custom-section {
  padding: 80px 0;
}

.custom-wrapper {
  position: relative;
  max-width: 1200px;
  margin: 50px auto 0;
  padding: 0 20px;
  min-height: 550px;
}

.custom-bg-img {
  position: absolute;
  left: 20px;
  top: 0;
  width: 450px;
  z-index: 1;
}

.custom-bg-img img {
  width: 100%;
  height: auto;
  border-radius: 8px;
}

.custom-content {
  position: relative;
  z-index: 3;
  margin-left: 490px;
  padding-top: 28px;
  text-align: left;
}

.custom-title {
  font-size: 24px;
  font-weight: bold;
  color: #000;
  margin-bottom: 20px;
}

.custom-text {
  font-size: 16px;
  line-height: 30px;
  color: #6d6d6d;
  margin-bottom: 20px;
}

.custom-list {
  list-style: none;
  color: #6d6d6d;
  font-size: 16px;
  line-height: 30px;
}

.custom-list li::before {
  content: "● ";
  color: #c40000;
  font-size: 10px;
  vertical-align: middle;
  margin-right: 8px;
}

.marquee-overlay {
  position: absolute;
  left: 241px;
  top: 380px;
  width: 917px;
  height: 220px;
  z-index: 2;
  overflow: hidden;
  background: #ffffff;
  border-radius: 10px;
}

.marquee-track {
  display: flex;
  gap: 40px;
  position: absolute;
  top: 0;
  left: 0;
  animation: marquee 25s linear infinite;
}

.marquee-track:hover {
  animation-play-state: paused;
}

@keyframes marquee {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50%);
  }
}

.marquee-card {
  width: 260px;
  height: 220px;
  flex-shrink: 0;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  position: relative;
}

.marquee-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;
}

.marquee-card:hover img {
  transform: scale(1.1);
}

@media (max-width: 768px) {
  .custom-bg-img {
    display: none;
  }

  .custom-content {
    margin-left: 0;
  }

  .marquee-overlay {
    position: relative;
    left: 0;
    top: 0;
    width: 100%;
    margin-top: 30px;
  }

  .product-card {
    width: 200px;

  }

  .service-block {
    grid-template-columns: 1fr;
  }

  .stats-grid {
    grid-template-columns: 1fr;
  }

  .scroll-arrow {
    display: none;
  }
}

/* 灯箱样式 */
.lightbox {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  animation: fadeIn 0.3s;
}

.lightbox-content {
  min-width: 600px;
  min-height: 600px;
  object-fit: contain;
  border-radius: 8px;
  animation: zoomIn 0.3s;
}

.lightbox-close {
  position: absolute;
  top: 20px;
  right: 40px;
  color: #fff;
  font-size: 40px;
  font-weight: bold;
  cursor: pointer;
  transition: 0.3s;
  z-index: 10000;
}

.lightbox-close:hover {
  color: #c40000;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes zoomIn {
  from {
    transform: scale(0.5);
  }

  to {
    transform: scale(1);
  }
}
</style>


// WEBPACK FOOTER //
// src/Home.vue